import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/erlang': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M87.2 53.5c-41.5 50.2-65.6 116.2-65.5 192.9-0.1 86.8 29 159.5 78.7 212.1h-100.4v-405h87.2zM325.4 63.2c46.2 0.1 79.6 33.5 80.7 83.2h-169.9c4.1-49.7 43.3-83.1 89.2-83.2zM556.1 53.6h0.3l-0.1-0.1zM556.4 53.6h83.6v405h-80.8c21.4-23 40.5-49.9 57.9-80.8l-96.4-48.2c-33.9 55.1-83.4 105.8-151.9 106.1-99.7-0.4-138.8-85.6-138.6-195.3h372.4c0.5-12.4 0.5-18.1 0-24.1 2.5-65.2-14.8-120-46.2-162.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/erlang.js
// module id = 811
// module chunks = 0